import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
//import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import DetailsCustomer from "./DetailsCustomer";
import EditCustomer from "./EditCustomer";
import $ from "jquery";

const ListCustomer = () => {
  const navigate = useNavigate();
  const {
    //userToken,
    setCustomerObj,
    setCustomerFlag,
    SetSharedObject,
    sharedObject,
    setSearchObj,
  } = useUserStore((state) => ({
    setCustomerObj: state.setCustomerObj,
    userToken: state.userToken,
    setCustomerFlag: state.setCustomerFlag,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    setSearchObj: state.setSearchObj,
  }));
  const [userObj, setUserObj] = useState([]);
  const [custInfo, setCustInfo] = useState();
  const [processing, SetProcessing] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [statusMessage, setStatusMessage] = useState("");
  const triggerRef = useRef(null);

  useEffect(() => {
    if (
      sharedObject.CustomerObj !== undefined &&
      sharedObject.CustomerObj !== null
    ) {
      userDetailsFunc(sharedObject.CustomerObj);
      getCust([sharedObject.CustomerObj]);
      SetSharedObject("CustomerObj", undefined);
    } else {
      getCust(sharedObject.vendorsObj);
    }
    // Also re-run when the backend customer list reloads (e.g. AWS<->GCP toggle),
    // so the list reflects the active backend without a manual page refresh.
  }, [sharedObject.refreshCustObj, sharedObject.vendorsObj]);

  const getCust = async (obj) => {
    SetProcessing(true);
    setStatusMessage("Loading customers�");

    const opt = ["Add Top Level Org", "Upload Org"];
    const tempObj = await Promise.all(
      (obj ?? []).map(async (row) => {
        // 1) fetch org count for this customer
        const orgCount = await fetchOrgCount(row.id);
        // 2) clickable customer name (unchanged)
        row.org = orgCount;
        const cs = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline"
            aria-label={`View details for customer ${row.name || "this customer"}`}
            onClick={() => userDetailsFunc(row, "show")}
          >
            <strong>{row.name}</strong>
          </button>
        );
        // 3) replace "VIEW" with the count (still clickable to go to /organizations)
        const vw = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline"
            onClick={() => ViewCustomer(row)}
            aria-label={`${orgCount} organization${orgCount !== 1 ? "s" : ""} for ${row.name}. Click to view.`}
          >
            <strong>{orgCount}</strong>
          </button>
        );
        // 4) actions (unchanged)
        const select = (
          <select
            onChange={(el) => userActions(row, el.target.value)}
            value={0}
            id={`UserActions-${row.id}`}
            aria-label={`Actions for ${row.name || "this customer"}`}
            className="form-control form-control-sm p-0 ht-4"
          >
            <option value="">Select</option>
            {opt.map((el, i) => (
              <option key={i} value={el}>
                {el}
              </option>
            ))}
          </select>
        );

        return {
          ...row,
          EditCourse: cs,
          View: vw, // shows the number instead of "VIEW"
          orgCount, // keep the raw number too (handy for sorting/filtering)
          Actions: select,
          Show: true,
          dCreated: new Date(row.dateCreated),
          timeStamp: Date.now(),
        };
      }),
    );

    setUserObj(tempObj);
    SetProcessing(false);
    // Sets a grammatically correct status message based on how many customer were loaded.
    setStatusMessage(`${tempObj.length} customer${tempObj.length !== 1 ? "s" : ""} loaded.`);
  };

  const userDetailsFunc = async (row) => {
    setSelectedProduct(row);
    setCustomerObj(row);
    setCustInfo({ ...row, timeStamp: Date.now() });
    let o = {
      Flag: "customer",
      Navigate: "customer",
      name: row.name,
      id: row.id,
    };
    SetSharedObject("UserIdEmail", o);
    $("#detailsCustomerModal").modal("show");
  };
  const userActions = async (row, type) => {
    let cust = {
      ...row,
      Name: row.name,
      Type: "top",
      OrgType: "top",
      VendorId: row.id,
    };
    setCustomerObj(cust); //
    SetSharedObject("orgActionObj", cust);
    SetSharedObject("CustomerPermissionsObj", cust);
    if (type === "Add Top Level Org") {
      setCustomerFlag(false);
      navigate("/toplevel-org-registration");
    } else {
      navigate("/upload-organization");
    }
  };
  const ViewCustomer = (row) => {
    SetSharedObject("CustomerPermissionsObj", row);
    row.Flag = "customer";
    row.Navigate = "customer";
    row.Name = row.name;
    setCustomerObj(row);
    setSearchObj({});
    SetSharedObject("UserIdEmail", row);
    navigate("/organizations");
  };

  const userEdit = (row) => {
     triggerRef.current = document.activeElement;
    $("#editCustomerModal").modal("show");
  };
  const userUpdate = (el) => {
    let tempObj = [];
    for (const row of userObj) {
      if (row.id === el.id) {
        row.billingAddress = el.billingAddress;
      }
      tempObj.push(row);
    }
    setUserObj(tempObj);
    userDetailsFunc(el);
    CloseModal();
  };
  const [nameSearch, setNameSearch] = useState("");

  const SearchCustomer = () => {
    console.log(nameSearch);
    if (nameSearch === "") {
      getCust(sharedObject.vendorsObj);
      return;
    }
    const newObj = userObj.filter((el) =>
      el.name.toUpperCase().includes(nameSearch.toUpperCase()),
    );
    setUserObj(newObj);
  };
  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchCustomer();
    }
  };
  const deletedDate = (dt) => {
    return dt.dateCreated
      ? new Date(dt.dateCreated).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const [sortFlag, SetSortFlag] = useState(false);
  const nameBodyTemplate = (product) => {
    SetSortFlag(!sortFlag);
    if (sortFlag) userObj.sort((a, b) => a.name.localeCompare(b.name));
    else userObj.sort((a, b) => b.name.localeCompare(a.name));
  };
  const createdByBodyTemplate = (row) => row?.createdBy?.split("|")[0];
  const fetchOrgCount = async (vendorId) => {
    const call = `/users/GetOrgsByCustID?vendorID=${parseInt(vendorId)}`;
    //const res = await CallAPI(call, false, "get", userToken);
    let obj = sharedObject.getOrgsObj;
    let temp = [];
    if (obj) {
      for (let elem of obj) {
        if (parseInt(vendorId) === elem.vendorId) {
          temp.push(elem);
        }
      }
    }

    return temp.length;
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        $('#editCustomerModal').modal('hide');
        triggerRef.current?.focus();
    };

  return (
    <main className="ListCustomer">
        <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className="sr-only"
          >
            {statusMessage}
      </div>
      <div className="HeaderCustomerTools">
        <div className="HeaderTools">
          <header className="ht-6">
            <h4 className="title-label3">List</h4>
            <div className="mid-header-bar">
              <div className="spacer-inline spacer-margin6">
              <label htmlFor="customerNameSearch" className="sr-only">
                  Search customers by name
                </label>
                <div className="input-group">
                  <input
                    type="search"
                    id="customerNameSearch"
                    className="form-control"
                    placeholder="Search by Name"
                    aria-describedby="SearchCustomer"
                    onChange={(el) => setNameSearch(el.target.value)}
                    onKeyDown={SearchWithEnter}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="SearchCustomer"
                      aria-label="Submit customer name search"
                      onClick={SearchCustomer}
                    >
                      <i className="bi bi-search" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
      {/*Grid*/}
      <section className="grid-layout" aria-label="Customer List">
        <DataTable
          value={userObj}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 25, 50]}
          tableStyle={{ minWidth: "50rem" }}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          selectionMode="single"
          selection={selectedProduct}
          onSelectionChange={(e) => setSelectedProduct(e.value)}
          columnResizeMode="expand"
          resizableColumns
          dataKey="id"
          metaKeySelection={false}
          sortField="dCreated"
          sortOrder={-1}
          aria-label="Customers"
          aria-busy={processing}
          loading={processing}
          loadingIcon={<span className="sr-only">Loading customers</span>}
          emptyMessage="No customers found."
        >
          <Column
            field="EditCourse"
            header="Customer Name"
            sortable
            sortField={(e) => nameBodyTemplate(e)}
          ></Column>
          <Column
            field="baseDomain.name"
            header="Base Domain"
            sortable
          ></Column>
          <Column
            field="orgCount"
            header="Organizations"
            className="w-md11 ctr"
            sortable
            body={(row) => row.View}
          ></Column>
          <Column
            field="dCreated"
            header="Date Created"
            className="w-md8"
            body={deletedDate}
            sortable
          ></Column>
          <Column
            field="billingAddress.city"
            header="City"
            className="w-md2"
            sortable
          ></Column>
          <Column
            field="billingAddress.state"
            header="State"
            className="w-sm"
            sortable
          ></Column>
          <Column
            field="billingAddress.zip"
            header="Zip"
            className="w-md11"
            sortable
          ></Column>
          <Column
            field="createdBy"
            header="Created By"
            className="w-md7"
            body={createdByBodyTemplate}
            sortable
          ></Column>
          <Column field="Actions" header="Actions" className="w-md2"></Column>
        </DataTable>
      </section>

      <DetailsCustomer
        userDetails={custInfo}
        CloseDetailUser={(el) => {
          setCustInfo(el);
        }}
        userEdit={userEdit}
      />

      <EditCustomer
        userDetails={custInfo}
        CloseDetailUser={(el) => {
            CloseModal();
        }}
        userUpdate={userUpdate}
      />
      {processing && (
        <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="loader-id"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="loader-id">{loadingText}</div>
        </div>
      )}
    </main>
  );
};

export default ListCustomer;
